import { createClient } from '@sanity/client';

export const client = createClient({
    projectId: 'tov39w1b', // Find this in Sanity project dashboard
    dataset: 'production', // Or your chosen dataset
    apiVersion: '2023-05-03', // Use a recent date for API version
    useCdn: false, // `false` if you want to ensure fresh data
});